module.exports = __webpack_public_path__ + "img/heart-outline.21a3db7d.svg";